module.exports = function() {
  return new Worker(__webpack_public_path__ + "633a4001552a427882e8.worker.js");
};